import React from 'react';
import Footer from '../components/global/footer';
import Header from '../components/global/header';

const TermsPage = ({ history }) => {
  const goHome = () => history.push('/');

  return (
    <div>
      <Header />
      <main className="about_main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="about_page">
                <h1 className="title text-center">Умови користування</h1>

                <div className="terms-content">
                  <p className="terms-subtitle">Вебсервіс «Лікарі 24/7»</p>
                  <p className="terms-edition">Редакція від 14.09.2026 • для публікації на <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">likari.in.ua</a></p>

                  <div className="terms-summary">
                    <strong>Коротко:</strong> «Лікарі 24/7» — пацієнтський вебсервіс, технологічно та функціонально пов’язаний з МІС «Каштан». Через Сервіс користувач може знайти медичного працівника або кабінет, переглянути доступний час і здійснити онлайн-запис у закладах охорони здоров’я, які використовують МІС «Каштан». Медичну допомогу надають відповідні заклади охорони здоров’я.
                  </div>

                  <section>
                    <h2>1. Загальні положення</h2>
                    <p><strong>1.1.</strong> Ці Умови визначають правила користування вебсервісом «Лікарі 24/7» за адресою <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">https://likari.in.ua</a> (далі — Сервіс).</p>
                    <p><strong>1.2.</strong> Для окремих функцій Сервісу може бути необхідна додаткова згода, ідентифікація, автентифікація або виконання інших умов, про які користувач повідомляється у відповідному сценарії.</p>
                    <p><strong>1.3.</strong> Оператором МІС «Каштан» є ТОВ «СІЕТ ХОЛДІНГ», код ЄДРПОУ 39197392. Товариство є розробником програмного забезпечення МІС «Каштан» та здійснює його технічну підтримку.</p>
                  </section>

                  <section>
                    <h2>2. Про Сервіс</h2>
                    <p><strong>2.1.</strong> «Лікарі 24/7» є пацієнтським вебсервісом, технологічно та функціонально пов’язаним з МІС «Каштан». Через Сервіс доступний пошук та онлайн-запис до медичних працівників і закладів охорони здоров’я, які використовують МІС «Каштан».</p>
                    <p><strong>2.2.</strong> Сервіс не є закладом охорони здоров’я та не надає медичної допомоги. Медичні послуги надаються відповідним закладом охорони здоров’я або медичним працівником.</p>
                    <p><strong>2.3.</strong> Сервіс не є державним Кабінетом пацієнта ЕСОЗ.</p>
                    <p><strong>2.4.</strong> Сервіс не призначений для звернення за екстреною медичною допомогою. У невідкладному стані слід звертатися за номером 103 або 112.</p>
                  </section>

                  <section>
                    <h2>3. Доступні функції</h2>
                    <p>Залежно від закладу охорони здоров’я та доступної функціональності Сервіс може надавати такі можливості:</p>
                    <ul>
                      <li>пошук медичного працівника, кабінету або доступної процедури;</li>
                      <li>перегляд інформації про заклад охорони здоров’я або медичного працівника;</li>
                      <li>перегляд доступного часу для запису;</li>
                      <li>створення онлайн-запису на прийом;</li>
                      <li>перегляд попередніх записів, а також перегляд та скасування майбутніх записів після автентифікації;</li>
                      <li>отримання сервісних повідомлень, пов’язаних з авторизацією та записом.</li>
                    </ul>
                    <p>Набір доступних функцій може відрізнятися залежно від конкретного закладу охорони здоров’я та технічної конфігурації Сервісу.</p>
                  </section>

                  <section>
                    <h2>4. Авторизація та безпека</h2>
                    <p><strong>4.1.</strong> Пошук медичного працівника або кабінету та перегляд доступного часу можуть бути доступні без входу до кабінету. Для створення онлайн-запису та використання персоналізованих функцій користувач проходить передбачену відповідним сценарієм ідентифікацію або автентифікацію.</p>
                    <p><strong>4.2.</strong> Користувач повинен надавати достовірні та актуальні дані, необхідні для відповідної дії, та не використовувати чужі засоби автентифікації без належних правових підстав.</p>
                    <p><strong>4.3.</strong> Одноразові коди, паролі та інші засоби доступу не слід передавати третім особам. У разі підозри на несанкціонований доступ рекомендується звернутися до служби технічної підтримки.</p>
                  </section>

                  <section>
                    <h2>5. Онлайн-запис</h2>
                    <p><strong>5.1.</strong> Користувач самостійно обирає з доступних у Сервісі варіантів заклад охорони здоров’я, медичного працівника або кабінет, дату та час прийому.</p>
                    <p><strong>5.2.</strong> Для окремих типів запису умовою може бути наявність електронного направлення, документів, що підтверджують право на відповідний вид обслуговування, або виконання інших вимог відповідного закладу охорони здоров’я.</p>
                    <p><strong>5.3.</strong> Доступність часу для запису відображається станом на момент перегляду та може змінюватися у зв’язку зі змінами розкладу, створенням або скасуванням інших записів чи технічними обставинами.</p>
                    <p><strong>5.4.</strong> Якщо для відповідного запису доступна функція скасування, користувач може скасувати майбутній запис у своєму кабінеті. Умови прийому та надання медичної допомоги визначає відповідний заклад охорони здоров’я.</p>
                  </section>

                  <section>
                    <h2>6. Інформація про заклади, медичних працівників і розклад</h2>
                    <p><strong>6.1.</strong> Відомості про заклади охорони здоров’я, медичних працівників, місця надання послуг, розклад та доступний час формуються на підставі даних відповідних закладів, що використовують МІС «Каштан».</p>
                    <p><strong>6.2.</strong> ТОВ «СІЕТ ХОЛДІНГ» забезпечує технічне відображення доступних у Сервісі даних у межах його функціональності. Питання щодо фактичного графіка роботи, умов прийому або медичних послуг доцільно уточнювати у відповідному закладі охорони здоров’я.</p>
                    <p><strong>6.3.</strong> Якщо користувач виявив очевидно некоректні або застарілі відомості у Сервісі, він може повідомити про це службу технічної підтримки.</p>
                  </section>

                  <section>
                    <h2>7. Сервісні повідомлення</h2>
                    <p><strong>7.1.</strong> У межах роботи Сервісу користувачу можуть надсилатися повідомлення, пов’язані з авторизацією, створенням, зміною, нагадуванням або скасуванням запису та іншими сервісними подіями.</p>
                    <p><strong>7.2.</strong> Доступність окремих повідомлень та канал їх надсилання можуть залежати від функціональності Сервісу та налаштувань відповідного сценарію.</p>
                  </section>

                  <section>
                    <h2>8. Вартість користування</h2>
                    <p><strong>8.1.</strong> ТОВ «СІЕТ ХОЛДІНГ» не стягує з користувачів плату за використання функцій пошуку та онлайн-запису через Сервіс.</p>
                    <p><strong>8.2.</strong> Медичні послуги відповідного закладу можуть бути безоплатними або платними. Умови їх надання та оплати визначає відповідний заклад охорони здоров’я.</p>
                  </section>

                  <section>
                    <h2>9. Правила допустимого використання</h2>
                    <p>Користувач повинен використовувати Сервіс лише у законний спосіб і в межах його призначення. Забороняється:</p>
                    <ul>
                      <li>намагатися отримати несанкціонований доступ до облікових записів, даних або технічної інфраструктури та втручатися в роботу Сервісу;</li>
                      <li>використовувати автоматизовані засоби для масового збору даних або створення надмірного навантаження на Сервіс без належного дозволу;</li>
                      <li>використовувати чужі персональні дані або Сервіс в інший спосіб, що порушує законодавство чи права інших осіб.</li>
                    </ul>
                  </section>

                  <section>
                    <h2>10. Доступність Сервісу, зміни функціоналу та відповідальність</h2>
                    <p><strong>10.1.</strong> Сервіс може тимчасово бути недоступним через технічні роботи, оновлення, аварії, перебої зв’язку або інші технічні обставини.</p>
                    <p><strong>10.2.</strong> Функціональність та структура інтерфейсу Сервісу можуть змінюватися в процесі його розвитку та технічного оновлення.</p>
                    <p><strong>10.3.</strong> ТОВ «СІЕТ ХОЛДІНГ» забезпечує технічне функціонування Сервісу в межах своєї компетенції. Медичну допомогу, медичні рішення, умови прийому та актуальність відомостей, що вносяться закладом охорони здоров’я, забезпечує відповідний заклад охорони здоров’я.</p>
                    <p><strong>10.4.</strong> Відповідальність сторін визначається законодавством України.</p>
                  </section>

                  <section>
                    <h2>11. Персональні дані, зміни Умов і контакти</h2>
                    <p><strong>11.1.</strong> Порядок обробки персональних даних під час користування Сервісом описаний у <a href="/privacy">Політиці конфіденційності</a>, опублікованій на сайті.</p>
                    <p><strong>11.2.</strong> Умови можуть періодично оновлюватися. Актуальна редакція із зазначенням дати публікується на <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">https://likari.in.ua</a>.</p>
                    <p><strong>11.3.</strong> До користування Сервісом застосовується законодавство України.</p>
                    <p><strong>11.4.</strong> Оператор МІС «Каштан»: ТОВ «СІЕТ ХОЛДІНГ», код ЄДРПОУ 39197392. Адреса: 01033, м. Київ, вул. Шота Руставелі, 33-Б, оф. 27. E-mail служби технічної підтримки: <a href="mailto:info@ciet-holding.com">info@ciet-holding.com</a>.</p>
                  </section>
                </div>

                <div className="link_to_home" onClick={goHome}>На головну</div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <style>{`
        .terms-content {
          line-height: 1.6;
          margin-bottom: 2rem;
          font-size: 16px;
        }

        .terms-content section {
          margin-bottom: 2.5rem;
        }

        .terms-content .terms-subtitle,
        .terms-content .terms-edition {
          text-align: center;
          color: #34495e;
        }

        .terms-content .terms-subtitle {
          margin-bottom: 0.4rem;
          font-size: 1.1rem;
          font-weight: 600;
        }

        .terms-content .terms-edition {
          margin-bottom: 3rem;
        }

        .terms-summary {
          margin-bottom: 3rem;
          padding: 1rem 1.25rem;
          background-color: #eef3f8;
          border-left: 4px solid #3498db;
          color: #2c3e50;
        }

        .terms-summary strong {
          color: #2c3e50;
        }

        .terms-content h2 {
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          color: #2c3e50;
          border-bottom: 2px solid #3498db;
          padding-bottom: 0.5rem;
        }

        .terms-content p {
          margin-bottom: 1.2rem;
          text-align: justify;
          color: #2c3e50;
        }

        .terms-content ul {
          list-style-type: disc;
          padding-left: 2rem;
          margin-bottom: 1.5rem;
        }

        .terms-content li {
          margin-bottom: 0.8rem;
          color: #2c3e50;
        }

        .terms-content strong {
          color: #2980b9;
          font-weight: 600;
        }

        .terms-content a {
          color: #3498db;
          text-decoration: none;
          font-weight: 500;
        }

        .terms-content a:hover {
          color: #2980b9;
          text-decoration: underline;
        }

        .link_to_home {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          background-color: #3498db;
          color: white;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
          margin-top: 2rem;
          text-decoration: none;
        }

        .link_to_home:hover {
          background-color: #2980b9;
          box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          transform: translateY(-1px);
        }

        @media (max-width: 768px) {
          .terms-content {
            font-size: 14px;
          }

          .terms-content h2 {
            font-size: 1.2rem;
          }

          .terms-content ul {
            padding-left: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsPage;
